// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as AirbnbShortTermRentalLoansRouteImport } from './routes/airbnb-short-term-rental-loans'
import { Route as ApplyRouteImport } from './routes/apply'
import { Route as ArvCalculatorRouteImport } from './routes/arv-calculator'
import { Route as AuthRouteImport } from './routes/auth'
import { Route as BestRentalMarketsRouteImport } from './routes/best-rental-markets'
import { Route as BridgeLoansRouteImport } from './routes/bridge-loans'
import { Route as BrrrrCalculatorRouteImport } from './routes/brrrr-calculator'
import { Route as CapRateCalculatorRouteImport } from './routes/cap-rate-calculator'
import { Route as CashOnCashReturnCalculatorRouteImport } from './routes/cash-on-cash-return-calculator'
import { Route as CashOutRefinanceCalculatorRouteImport } from './routes/cash-out-refinance-calculator'
import { Route as ClosingCostCalculatorRouteImport } from './routes/closing-cost-calculator'
import { Route as ConstructionLoansRouteImport } from './routes/construction-loans'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DifficultDevelopmentAreasRouteImport } from './routes/difficult-development-areas'
import { Route as DscrCalculatorRouteImport } from './routes/dscr-calculator'
import { Route as DscrCashOutRefinanceRouteImport } from './routes/dscr-cash-out-refinance'
import { Route as DscrHelocRouteImport } from './routes/dscr-heloc'
import { Route as DscrHelocRatesRouteImport } from './routes/dscr-heloc-rates'
import { Route as DscrLoanProsAndConsRouteImport } from './routes/dscr-loan-pros-and-cons'
import { Route as DscrLoanRatesRouteImport } from './routes/dscr-loan-rates'
import { Route as DscrLoanRequirementsRouteImport } from './routes/dscr-loan-requirements'
import { Route as DscrLoansRouteImport } from './routes/dscr-loans'
import { Route as DscrPaymentCalculatorRouteImport } from './routes/dscr-payment-calculator'
import { Route as DscrRateHistoryRouteImport } from './routes/dscr-rate-history'
import { Route as DscrRateTermRefinanceRouteImport } from './routes/dscr-rate-term-refinance'
import { Route as DscrSecondLienHelocRouteImport } from './routes/dscr-second-lien-heloc'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as FhaLoanRatesRouteImport } from './routes/fha-loan-rates'
import { Route as FixAndFlipLoansRouteImport } from './routes/fix-and-flip-loans'
import { Route as ForeignNationalLoansRouteImport } from './routes/foreign-national-loans'
import { Route as HardMoneyLoansRouteImport } from './routes/hard-money-loans'
import { Route as HowDscrWorksRouteImport } from './routes/how-dscr-works'
import { Route as HudFairMarketRentsRouteImport } from './routes/hud-fair-market-rents'
import { Route as HudIncomeLimitsRouteImport } from './routes/hud-income-limits'
import { Route as InterestOnlyDscrLoansRouteImport } from './routes/interest-only-dscr-loans'
import { Route as InterestOnlyVsAmortizingCalculatorRouteImport } from './routes/interest-only-vs-amortizing-calculator'
import { Route as InvestmentPropertyRatesRouteImport } from './routes/investment-property-rates'
import { Route as InvestorJourneyRouteImport } from './routes/investor-journey'
import { Route as LtvEquityCalculatorRouteImport } from './routes/ltv-equity-calculator'
import { Route as MidTermRentalLoansRouteImport } from './routes/mid-term-rental-loans'
import { Route as MultifamilyLoansRouteImport } from './routes/multifamily-loans'
import { Route as NoRatioDscrLoansRouteImport } from './routes/no-ratio-dscr-loans'
import { Route as PartnersRouteImport } from './routes/partners'
import { Route as PortfolioRentalLoansRouteImport } from './routes/portfolio-rental-loans'
import { Route as PrepaymentPenaltyCalculatorRouteImport } from './routes/prepayment-penalty-calculator'
import { Route as ProcessRouteImport } from './routes/process'
import { Route as QualifiedCensusTractsRouteImport } from './routes/qualified-census-tracts'
import { Route as RatesRouteImport } from './routes/rates'
import { Route as RentNeededForDscrRouteImport } from './routes/rent-needed-for-dscr'
import { Route as RentalPropertyDealAnalyzerRouteImport } from './routes/rental-property-deal-analyzer'
import { Route as ResetPasswordRouteImport } from './routes/reset-password'
import { Route as Section8InvestingMapRouteImport } from './routes/section-8-investing-map'
import { Route as Section8LoansRouteImport } from './routes/section-8-loans'
import { Route as ThankYouRouteImport } from './routes/thank-you'
import { Route as UnsubscribeRouteImport } from './routes/unsubscribe'
import { Route as WhereWeLendRouteImport } from './routes/where-we-lend'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminApiHealthRouteImport } from './routes/admin.api-health'
import { Route as AdminBlogAgentRouteImport } from './routes/admin.blog-agent'
import { Route as AdminBlogCalendarRouteImport } from './routes/admin.blog-calendar'
import { Route as AdminBlogClustersRouteImport } from './routes/admin.blog-clusters'
import { Route as AdminBlogGscOpportunitiesRouteImport } from './routes/admin.blog-gsc-opportunities'
import { Route as AdminBlogPublishQueueRouteImport } from './routes/admin.blog-publish-queue'
import { Route as AdminBlogScheduleRouteImport } from './routes/admin.blog-schedule'
import { Route as AdminBlogStatsRouteImport } from './routes/admin.blog-stats'
import { Route as AdminBlogTopicsRouteImport } from './routes/admin.blog-topics'
import { Route as AdminBlogVideosRouteImport } from './routes/admin.blog-videos'
import { Route as AdminComplianceRouteImport } from './routes/admin.compliance'
import { Route as AdminEmailsRouteImport } from './routes/admin.emails'
import { Route as AdminHelocPricingRouteImport } from './routes/admin.heloc-pricing'
import { Route as AdminIntegrationsHealthRouteImport } from './routes/admin.integrations-health'
import { Route as AdminLeadsRouteImport } from './routes/admin.leads'
import { Route as AdminOptimalBlueRouteImport } from './routes/admin.optimal-blue'
import { Route as AdminPostsRouteImport } from './routes/admin.posts'
import { Route as AdminPricingGroupsRouteImport } from './routes/admin.pricing-groups'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminSiteAuditRouteImport } from './routes/admin.site-audit'
import { Route as AdminSocialRouteImport } from './routes/admin.social'
import { Route as AdminToolsRouteImport } from './routes/admin.tools'
import { Route as AirbnbShortTermRentalLoansIndexRouteImport } from './routes/airbnb-short-term-rental-loans.index'
import { Route as AirbnbShortTermRentalLoansStateRouteImport } from './routes/airbnb-short-term-rental-loans.$state'
import { Route as ApplyIndexRouteImport } from './routes/apply.index'
import { Route as BlogIndexRouteImport } from './routes/blog.index'
import { Route as BlogSlugRouteImport } from './routes/blog.$slug'
import { Route as BridgeLoansIndexRouteImport } from './routes/bridge-loans.index'
import { Route as BusinessSetupIndexRouteImport } from './routes/business-setup.index'
import { Route as BusinessSetupBusinessBankAccountRouteImport } from './routes/business-setup.business-bank-account'
import { Route as BusinessSetupBusinessLoansRouteImport } from './routes/business-setup.business-loans'
import { Route as BusinessSetupDunsNumberRouteImport } from './routes/business-setup.duns-number'
import { Route as BusinessSetupItinRouteImport } from './routes/business-setup.itin'
import { Route as BusinessSetupLandlordInsuranceRouteImport } from './routes/business-setup.landlord-insurance'
import { Route as BusinessSetupLlcRouteImport } from './routes/business-setup.llc'
import { Route as BusinessSetupLlcJourneyRouteImport } from './routes/business-setup.llc-journey'
import { Route as BusinessSetupPropertyManagementSoftwareRouteImport } from './routes/business-setup.property-management-software'
import { Route as BusinessSetupTitleServicesRouteImport } from './routes/business-setup.title-services'
import { Route as CompareIndexRouteImport } from './routes/compare.index'
import { Route as CompareSlugRouteImport } from './routes/compare.$slug'
import { Route as ConstructionLoansIndexRouteImport } from './routes/construction-loans.index'
import { Route as ConstructionLoansStateRouteImport } from './routes/construction-loans.$state'
import { Route as DifficultDevelopmentAreasIndexRouteImport } from './routes/difficult-development-areas.index'
import { Route as DifficultDevelopmentAreasStateRouteImport } from './routes/difficult-development-areas.$state'
import { Route as DscrLoansIndexRouteImport } from './routes/dscr-loans.index'
import { Route as DscrLoansStateRouteImport } from './routes/dscr-loans.$state'
import { Route as EsIndexRouteImport } from './routes/es.index'
import { Route as EsSplatRouteImport } from './routes/es.$'
import { Route as EsBlogRouteImport } from './routes/es.blog'
import { Route as EsCalculadoraDscrRouteImport } from './routes/es.calculadora-dscr'
import { Route as EsCaminoDelInversionistaRouteImport } from './routes/es.camino-del-inversionista'
import { Route as EsComoFuncionaDscrRouteImport } from './routes/es.como-funciona-dscr'
import { Route as EsContactoRouteImport } from './routes/es.contacto'
import { Route as EsDondePrestamosRouteImport } from './routes/es.donde-prestamos'
import { Route as EsGraciasRouteImport } from './routes/es.gracias'
import { Route as EsPreguntasFrecuentesRouteImport } from './routes/es.preguntas-frecuentes'
import { Route as EsPrestamosDscrRouteImport } from './routes/es.prestamos-dscr'
import { Route as EsPrestamosExtranjerosRouteImport } from './routes/es.prestamos-extranjeros'
import { Route as EsPrestamosFixAndFlipRouteImport } from './routes/es.prestamos-fix-and-flip'
import { Route as EsProcesoRouteImport } from './routes/es.proceso'
import { Route as EsRequisitosPrestamoDscrRouteImport } from './routes/es.requisitos-prestamo-dscr'
import { Route as EsSobreNosotrosRouteImport } from './routes/es.sobre-nosotros'
import { Route as EsSociosRouteImport } from './routes/es.socios'
import { Route as EsSolicitarRouteImport } from './routes/es.solicitar'
import { Route as EsTasasPrestamosDscrRouteImport } from './routes/es.tasas-prestamos-dscr'
import { Route as FixAndFlipLoansIndexRouteImport } from './routes/fix-and-flip-loans.index'
import { Route as ForeignNationalLoansIndexRouteImport } from './routes/foreign-national-loans.index'
import { Route as ForeignNationalLoansStateRouteImport } from './routes/foreign-national-loans.$state'
import { Route as GlossaryIndexRouteImport } from './routes/glossary.index'
import { Route as GlossaryTermRouteImport } from './routes/glossary.$term'
import { Route as HardMoneyLoansIndexRouteImport } from './routes/hard-money-loans.index'
import { Route as HudFairMarketRentsIndexRouteImport } from './routes/hud-fair-market-rents.index'
import { Route as HudFairMarketRentsStateRouteImport } from './routes/hud-fair-market-rents.$state'
import { Route as HudIncomeLimitsIndexRouteImport } from './routes/hud-income-limits.index'
import { Route as HudIncomeLimitsStateRouteImport } from './routes/hud-income-limits.$state'
import { Route as LegalAccessibilityRouteImport } from './routes/legal.accessibility'
import { Route as LegalCalculatorMethodologyRouteImport } from './routes/legal.calculator-methodology'
import { Route as LegalDisclaimersRouteImport } from './routes/legal.disclaimers'
import { Route as LegalEditorialStandardsRouteImport } from './routes/legal.editorial-standards'
import { Route as LegalLicensingRouteImport } from './routes/legal.licensing'
import { Route as LegalPrivacyRouteImport } from './routes/legal.privacy'
import { Route as LegalTermsRouteImport } from './routes/legal.terms'
import { Route as LoIndexRouteImport } from './routes/lo.index'
import { Route as LoDocumentsRouteImport } from './routes/lo.documents'
import { Route as LoGuidelinesRouteImport } from './routes/lo.guidelines'
import { Route as LoStrReportRouteImport } from './routes/lo.str-report'
import { Route as MultifamilyLoansIndexRouteImport } from './routes/multifamily-loans.index'
import { Route as PortfolioRentalLoansIndexRouteImport } from './routes/portfolio-rental-loans.index'
import { Route as QualifiedCensusTractsIndexRouteImport } from './routes/qualified-census-tracts.index'
import { Route as QualifiedCensusTractsStateRouteImport } from './routes/qualified-census-tracts.$state'
import { Route as Section8LoansIndexRouteImport } from './routes/section-8-loans.index'
import { Route as Section8LoansStateRouteImport } from './routes/section-8-loans.$state'
import { Route as ToolsCompareCitiesRouteImport } from './routes/tools.compare-cities'
import { Route as AdminBlogStatsIdRouteImport } from './routes/admin.blog-stats.$id'
import { Route as AdminChatbotIndexRouteImport } from './routes/admin.chatbot.index'
import { Route as AdminChatbotConversationsRouteImport } from './routes/admin.chatbot.conversations'
import { Route as AdminChatbotKnowledgeRouteImport } from './routes/admin.chatbot.knowledge'
import { Route as AdminChatbotReviewRouteImport } from './routes/admin.chatbot.review'
import { Route as AdminChatbotTrainingRouteImport } from './routes/admin.chatbot.training'
import { Route as AdminChatbotTransferRouteImport } from './routes/admin.chatbot.transfer'
import { Route as AdminPostsIndexRouteImport } from './routes/admin.posts.index'
import { Route as AdminPostsIdRouteImport } from './routes/admin.posts.$id'
import { Route as AdminPostsNewRouteImport } from './routes/admin.posts.new'
import { Route as AdminSeoIndexRouteImport } from './routes/admin.seo.index'
import { Route as AdminSeoAiVisibilityRouteImport } from './routes/admin.seo.ai-visibility'
import { Route as AdminSeoAutopilotRouteImport } from './routes/admin.seo.autopilot'
import { Route as AdminSeoCannibalizationRouteImport } from './routes/admin.seo.cannibalization'
import { Route as AdminSeoCompetitorsRouteImport } from './routes/admin.seo.competitors'
import { Route as AdminSeoContentFreshnessRouteImport } from './routes/admin.seo.content-freshness'
import { Route as AdminSeoContentHygieneRouteImport } from './routes/admin.seo.content-hygiene'
import { Route as AdminSeoConversionsRouteImport } from './routes/admin.seo.conversions'
import { Route as AdminSeoCtrRouteImport } from './routes/admin.seo.ctr'
import { Route as AdminSeoCycleRouteImport } from './routes/admin.seo.cycle'
import { Route as AdminSeoFirecrawlRouteImport } from './routes/admin.seo.firecrawl'
import { Route as AdminSeoFixCenterRouteImport } from './routes/admin.seo.fix-center'
import { Route as AdminSeoIndexCoverageRouteImport } from './routes/admin.seo.index-coverage'
import { Route as AdminSeoIntegrationsRouteImport } from './routes/admin.seo.integrations'
import { Route as AdminSeoInternalLinksRouteImport } from './routes/admin.seo.internal-links'
import { Route as AdminSeoLinkCheckRouteImport } from './routes/admin.seo.link-check'
import { Route as AdminSeoLinkInjectorRouteImport } from './routes/admin.seo.link-injector'
import { Route as AdminSeoMissingPagesRouteImport } from './routes/admin.seo.missing-pages'
import { Route as AdminSeoPerformanceRouteImport } from './routes/admin.seo.performance'
import { Route as AdminSeoPublishActionsRouteImport } from './routes/admin.seo.publish-actions'
import { Route as AdminSeoQaImpactRouteImport } from './routes/admin.seo.qa-impact'
import { Route as AdminSeoRankTrackerRouteImport } from './routes/admin.seo.rank-tracker'
import { Route as AdminSeoReportsRouteImport } from './routes/admin.seo.reports'
import { Route as AdminSeoRulesRouteImport } from './routes/admin.seo.rules'
import { Route as AdminSeoSiteHealthRouteImport } from './routes/admin.seo.site-health'
import { Route as AdminSeoTopicGapsRouteImport } from './routes/admin.seo.topic-gaps'
import { Route as AdminSeoWebVitalsRouteImport } from './routes/admin.seo.web-vitals'
import { Route as AdminSocialIndexRouteImport } from './routes/admin.social.index'
import { Route as AdminSocialAccountsRouteImport } from './routes/admin.social.accounts'
import { Route as AdminSocialAnalyticsRouteImport } from './routes/admin.social.analytics'
import { Route as AdminSocialBulkRouteImport } from './routes/admin.social.bulk'
import { Route as AdminSocialCalendarRouteImport } from './routes/admin.social.calendar'
import { Route as AdminSocialCommentsRouteImport } from './routes/admin.social.comments'
import { Route as AdminSocialComplianceRouteImport } from './routes/admin.social.compliance'
import { Route as AdminSocialComposeRouteImport } from './routes/admin.social.compose'
import { Route as AdminSocialConnectRouteImport } from './routes/admin.social.connect'
import { Route as AdminSocialConnectGhlRouteImport } from './routes/admin.social.connect-ghl'
import { Route as AdminSocialDiagnosticsRouteImport } from './routes/admin.social.diagnostics'
import { Route as AdminSocialDraftsRouteImport } from './routes/admin.social.drafts'
import { Route as AdminSocialEvergreenRouteImport } from './routes/admin.social.evergreen'
import { Route as AdminSocialEvergreenGuideRouteImport } from './routes/admin.social.evergreen-guide'
import { Route as AdminSocialGuideRouteImport } from './routes/admin.social.guide'
import { Route as AdminSocialInboxRouteImport } from './routes/admin.social.inbox'
import { Route as AdminSocialQueueRouteImport } from './routes/admin.social.queue'
import { Route as AdminSocialReplyLogRouteImport } from './routes/admin.social.reply-log'
import { Route as AdminSocialSettingsRouteImport } from './routes/admin.social.settings'
import { Route as AdminSocialSetupGuideRouteImport } from './routes/admin.social.setup-guide'
import { Route as AdminSocialTeamSetupRouteImport } from './routes/admin.social.team-setup'
import { Route as AirbnbShortTermRentalLoansStateIndexRouteImport } from './routes/airbnb-short-term-rental-loans.$state.index'
import { Route as AirbnbShortTermRentalLoansStateCityRouteImport } from './routes/airbnb-short-term-rental-loans.$state.$city'
import { Route as ApplyThanksProductRouteImport } from './routes/apply.thanks.$product'
import { Route as BridgeLoansStateIndexRouteImport } from './routes/bridge-loans.$state.index'
import { Route as BridgeLoansStateCityRouteImport } from './routes/bridge-loans.$state.$city'
import { Route as ConstructionLoansStateIndexRouteImport } from './routes/construction-loans.$state.index'
import { Route as ConstructionLoansStateCityRouteImport } from './routes/construction-loans.$state.$city'
import { Route as DscrLoansStateIndexRouteImport } from './routes/dscr-loans.$state.index'
import { Route as DscrLoansStateCityRouteImport } from './routes/dscr-loans.$state.$city'
import { Route as EsLegalAccesibilidadRouteImport } from './routes/es.legal.accesibilidad'
import { Route as EsLegalDivulgacionesRouteImport } from './routes/es.legal.divulgaciones'
import { Route as EsLegalLicenciasRouteImport } from './routes/es.legal.licencias'
import { Route as EsLegalPrivacidadRouteImport } from './routes/es.legal.privacidad'
import { Route as EsLegalTerminosRouteImport } from './routes/es.legal.terminos'
import { Route as EsPrestamosDscrIndexRouteImport } from './routes/es.prestamos-dscr.index'
import { Route as EsSolicitarIndexRouteImport } from './routes/es.solicitar.index'
import { Route as FixAndFlipLoansStateIndexRouteImport } from './routes/fix-and-flip-loans.$state.index'
import { Route as FixAndFlipLoansStateCityRouteImport } from './routes/fix-and-flip-loans.$state.$city'
import { Route as ForeignNationalLoansStateIndexRouteImport } from './routes/foreign-national-loans.$state.index'
import { Route as ForeignNationalLoansStateCityRouteImport } from './routes/foreign-national-loans.$state.$city'
import { Route as HardMoneyLoansStateIndexRouteImport } from './routes/hard-money-loans.$state.index'
import { Route as MultifamilyLoansStateIndexRouteImport } from './routes/multifamily-loans.$state.index'
import { Route as PortfolioRentalLoansStateIndexRouteImport } from './routes/portfolio-rental-loans.$state.index'
import { Route as PortfolioRentalLoansStateCityRouteImport } from './routes/portfolio-rental-loans.$state.$city'
import { Route as Section8LoansStateIndexRouteImport } from './routes/section-8-loans.$state.index'
import { Route as Section8LoansStateCityRouteImport } from './routes/section-8-loans.$state.$city'
import { Route as AdminPostsIdPreviewRouteImport } from './routes/admin.posts.$id_.preview'

const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const AboutRoute = AboutRouteImport.update({
            id: '/about',path: '/about',getParentRoute: () => rootRouteImport
          })
const AdminRoute = AdminRouteImport.update({
            id: '/admin',path: '/admin',getParentRoute: () => rootRouteImport
          })
const AirbnbShortTermRentalLoansRoute = AirbnbShortTermRentalLoansRouteImport.update({
            id: '/airbnb-short-term-rental-loans',path: '/airbnb-short-term-rental-loans',getParentRoute: () => rootRouteImport
          })
const ApplyRoute = ApplyRouteImport.update({
            id: '/apply',path: '/apply',getParentRoute: () => rootRouteImport
          })
const ArvCalculatorRoute = ArvCalculatorRouteImport.update({
            id: '/arv-calculator',path: '/arv-calculator',getParentRoute: () => rootRouteImport
          })
const AuthRoute = AuthRouteImport.update({
            id: '/auth',path: '/auth',getParentRoute: () => rootRouteImport
          })
const BestRentalMarketsRoute = BestRentalMarketsRouteImport.update({
            id: '/best-rental-markets',path: '/best-rental-markets',getParentRoute: () => rootRouteImport
          })
const BridgeLoansRoute = BridgeLoansRouteImport.update({
            id: '/bridge-loans',path: '/bridge-loans',getParentRoute: () => rootRouteImport
          })
const BrrrrCalculatorRoute = BrrrrCalculatorRouteImport.update({
            id: '/brrrr-calculator',path: '/brrrr-calculator',getParentRoute: () => rootRouteImport
          })
const CapRateCalculatorRoute = CapRateCalculatorRouteImport.update({
            id: '/cap-rate-calculator',path: '/cap-rate-calculator',getParentRoute: () => rootRouteImport
          })
const CashOnCashReturnCalculatorRoute = CashOnCashReturnCalculatorRouteImport.update({
            id: '/cash-on-cash-return-calculator',path: '/cash-on-cash-return-calculator',getParentRoute: () => rootRouteImport
          })
const CashOutRefinanceCalculatorRoute = CashOutRefinanceCalculatorRouteImport.update({
            id: '/cash-out-refinance-calculator',path: '/cash-out-refinance-calculator',getParentRoute: () => rootRouteImport
          })
const ClosingCostCalculatorRoute = ClosingCostCalculatorRouteImport.update({
            id: '/closing-cost-calculator',path: '/closing-cost-calculator',getParentRoute: () => rootRouteImport
          })
const ConstructionLoansRoute = ConstructionLoansRouteImport.update({
            id: '/construction-loans',path: '/construction-loans',getParentRoute: () => rootRouteImport
          })
const ContactRoute = ContactRouteImport.update({
            id: '/contact',path: '/contact',getParentRoute: () => rootRouteImport
          })
const DifficultDevelopmentAreasRoute = DifficultDevelopmentAreasRouteImport.update({
            id: '/difficult-development-areas',path: '/difficult-development-areas',getParentRoute: () => rootRouteImport
          })
const DscrCalculatorRoute = DscrCalculatorRouteImport.update({
            id: '/dscr-calculator',path: '/dscr-calculator',getParentRoute: () => rootRouteImport
          })
const DscrCashOutRefinanceRoute = DscrCashOutRefinanceRouteImport.update({
            id: '/dscr-cash-out-refinance',path: '/dscr-cash-out-refinance',getParentRoute: () => rootRouteImport
          })
const DscrHelocRoute = DscrHelocRouteImport.update({
            id: '/dscr-heloc',path: '/dscr-heloc',getParentRoute: () => rootRouteImport
          })
const DscrHelocRatesRoute = DscrHelocRatesRouteImport.update({
            id: '/dscr-heloc-rates',path: '/dscr-heloc-rates',getParentRoute: () => rootRouteImport
          })
const DscrLoanProsAndConsRoute = DscrLoanProsAndConsRouteImport.update({
            id: '/dscr-loan-pros-and-cons',path: '/dscr-loan-pros-and-cons',getParentRoute: () => rootRouteImport
          })
const DscrLoanRatesRoute = DscrLoanRatesRouteImport.update({
            id: '/dscr-loan-rates',path: '/dscr-loan-rates',getParentRoute: () => rootRouteImport
          })
const DscrLoanRequirementsRoute = DscrLoanRequirementsRouteImport.update({
            id: '/dscr-loan-requirements',path: '/dscr-loan-requirements',getParentRoute: () => rootRouteImport
          })
const DscrLoansRoute = DscrLoansRouteImport.update({
            id: '/dscr-loans',path: '/dscr-loans',getParentRoute: () => rootRouteImport
          })
const DscrPaymentCalculatorRoute = DscrPaymentCalculatorRouteImport.update({
            id: '/dscr-payment-calculator',path: '/dscr-payment-calculator',getParentRoute: () => rootRouteImport
          })
const DscrRateHistoryRoute = DscrRateHistoryRouteImport.update({
            id: '/dscr-rate-history',path: '/dscr-rate-history',getParentRoute: () => rootRouteImport
          })
const DscrRateTermRefinanceRoute = DscrRateTermRefinanceRouteImport.update({
            id: '/dscr-rate-term-refinance',path: '/dscr-rate-term-refinance',getParentRoute: () => rootRouteImport
          })
const DscrSecondLienHelocRoute = DscrSecondLienHelocRouteImport.update({
            id: '/dscr-second-lien-heloc',path: '/dscr-second-lien-heloc',getParentRoute: () => rootRouteImport
          })
const FaqRoute = FaqRouteImport.update({
            id: '/faq',path: '/faq',getParentRoute: () => rootRouteImport
          })
const FhaLoanRatesRoute = FhaLoanRatesRouteImport.update({
            id: '/fha-loan-rates',path: '/fha-loan-rates',getParentRoute: () => rootRouteImport
          })
const FixAndFlipLoansRoute = FixAndFlipLoansRouteImport.update({
            id: '/fix-and-flip-loans',path: '/fix-and-flip-loans',getParentRoute: () => rootRouteImport
          })
const ForeignNationalLoansRoute = ForeignNationalLoansRouteImport.update({
            id: '/foreign-national-loans',path: '/foreign-national-loans',getParentRoute: () => rootRouteImport
          })
const HardMoneyLoansRoute = HardMoneyLoansRouteImport.update({
            id: '/hard-money-loans',path: '/hard-money-loans',getParentRoute: () => rootRouteImport
          })
const HowDscrWorksRoute = HowDscrWorksRouteImport.update({
            id: '/how-dscr-works',path: '/how-dscr-works',getParentRoute: () => rootRouteImport
          })
const HudFairMarketRentsRoute = HudFairMarketRentsRouteImport.update({
            id: '/hud-fair-market-rents',path: '/hud-fair-market-rents',getParentRoute: () => rootRouteImport
          })
const HudIncomeLimitsRoute = HudIncomeLimitsRouteImport.update({
            id: '/hud-income-limits',path: '/hud-income-limits',getParentRoute: () => rootRouteImport
          })
const InterestOnlyDscrLoansRoute = InterestOnlyDscrLoansRouteImport.update({
            id: '/interest-only-dscr-loans',path: '/interest-only-dscr-loans',getParentRoute: () => rootRouteImport
          })
const InterestOnlyVsAmortizingCalculatorRoute = InterestOnlyVsAmortizingCalculatorRouteImport.update({
            id: '/interest-only-vs-amortizing-calculator',path: '/interest-only-vs-amortizing-calculator',getParentRoute: () => rootRouteImport
          })
const InvestmentPropertyRatesRoute = InvestmentPropertyRatesRouteImport.update({
            id: '/investment-property-rates',path: '/investment-property-rates',getParentRoute: () => rootRouteImport
          })
const InvestorJourneyRoute = InvestorJourneyRouteImport.update({
            id: '/investor-journey',path: '/investor-journey',getParentRoute: () => rootRouteImport
          })
const LtvEquityCalculatorRoute = LtvEquityCalculatorRouteImport.update({
            id: '/ltv-equity-calculator',path: '/ltv-equity-calculator',getParentRoute: () => rootRouteImport
          })
const MidTermRentalLoansRoute = MidTermRentalLoansRouteImport.update({
            id: '/mid-term-rental-loans',path: '/mid-term-rental-loans',getParentRoute: () => rootRouteImport
          })
const MultifamilyLoansRoute = MultifamilyLoansRouteImport.update({
            id: '/multifamily-loans',path: '/multifamily-loans',getParentRoute: () => rootRouteImport
          })
const NoRatioDscrLoansRoute = NoRatioDscrLoansRouteImport.update({
            id: '/no-ratio-dscr-loans',path: '/no-ratio-dscr-loans',getParentRoute: () => rootRouteImport
          })
const PartnersRoute = PartnersRouteImport.update({
            id: '/partners',path: '/partners',getParentRoute: () => rootRouteImport
          })
const PortfolioRentalLoansRoute = PortfolioRentalLoansRouteImport.update({
            id: '/portfolio-rental-loans',path: '/portfolio-rental-loans',getParentRoute: () => rootRouteImport
          })
const PrepaymentPenaltyCalculatorRoute = PrepaymentPenaltyCalculatorRouteImport.update({
            id: '/prepayment-penalty-calculator',path: '/prepayment-penalty-calculator',getParentRoute: () => rootRouteImport
          })
const ProcessRoute = ProcessRouteImport.update({
            id: '/process',path: '/process',getParentRoute: () => rootRouteImport
          })
const QualifiedCensusTractsRoute = QualifiedCensusTractsRouteImport.update({
            id: '/qualified-census-tracts',path: '/qualified-census-tracts',getParentRoute: () => rootRouteImport
          })
const RatesRoute = RatesRouteImport.update({
            id: '/rates',path: '/rates',getParentRoute: () => rootRouteImport
          })
const RentNeededForDscrRoute = RentNeededForDscrRouteImport.update({
            id: '/rent-needed-for-dscr',path: '/rent-needed-for-dscr',getParentRoute: () => rootRouteImport
          })
const RentalPropertyDealAnalyzerRoute = RentalPropertyDealAnalyzerRouteImport.update({
            id: '/rental-property-deal-analyzer',path: '/rental-property-deal-analyzer',getParentRoute: () => rootRouteImport
          })
const ResetPasswordRoute = ResetPasswordRouteImport.update({
            id: '/reset-password',path: '/reset-password',getParentRoute: () => rootRouteImport
          })
const Section8InvestingMapRoute = Section8InvestingMapRouteImport.update({
            id: '/section-8-investing-map',path: '/section-8-investing-map',getParentRoute: () => rootRouteImport
          })
const Section8LoansRoute = Section8LoansRouteImport.update({
            id: '/section-8-loans',path: '/section-8-loans',getParentRoute: () => rootRouteImport
          })
const ThankYouRoute = ThankYouRouteImport.update({
            id: '/thank-you',path: '/thank-you',getParentRoute: () => rootRouteImport
          })
const UnsubscribeRoute = UnsubscribeRouteImport.update({
            id: '/unsubscribe',path: '/unsubscribe',getParentRoute: () => rootRouteImport
          })
const WhereWeLendRoute = WhereWeLendRouteImport.update({
            id: '/where-we-lend',path: '/where-we-lend',getParentRoute: () => rootRouteImport
          })
const AdminIndexRoute = AdminIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminRoute
          })
const AdminApiHealthRoute = AdminApiHealthRouteImport.update({
            id: '/api-health',path: '/api-health',getParentRoute: () => AdminRoute
          })
const AdminBlogAgentRoute = AdminBlogAgentRouteImport.update({
            id: '/blog-agent',path: '/blog-agent',getParentRoute: () => AdminRoute
          })
const AdminBlogCalendarRoute = AdminBlogCalendarRouteImport.update({
            id: '/blog-calendar',path: '/blog-calendar',getParentRoute: () => AdminRoute
          })
const AdminBlogClustersRoute = AdminBlogClustersRouteImport.update({
            id: '/blog-clusters',path: '/blog-clusters',getParentRoute: () => AdminRoute
          })
const AdminBlogGscOpportunitiesRoute = AdminBlogGscOpportunitiesRouteImport.update({
            id: '/blog-gsc-opportunities',path: '/blog-gsc-opportunities',getParentRoute: () => AdminRoute
          })
const AdminBlogPublishQueueRoute = AdminBlogPublishQueueRouteImport.update({
            id: '/blog-publish-queue',path: '/blog-publish-queue',getParentRoute: () => AdminRoute
          })
const AdminBlogScheduleRoute = AdminBlogScheduleRouteImport.update({
            id: '/blog-schedule',path: '/blog-schedule',getParentRoute: () => AdminRoute
          })
const AdminBlogStatsRoute = AdminBlogStatsRouteImport.update({
            id: '/blog-stats',path: '/blog-stats',getParentRoute: () => AdminRoute
          })
const AdminBlogTopicsRoute = AdminBlogTopicsRouteImport.update({
            id: '/blog-topics',path: '/blog-topics',getParentRoute: () => AdminRoute
          })
const AdminBlogVideosRoute = AdminBlogVideosRouteImport.update({
            id: '/blog-videos',path: '/blog-videos',getParentRoute: () => AdminRoute
          })
const AdminComplianceRoute = AdminComplianceRouteImport.update({
            id: '/compliance',path: '/compliance',getParentRoute: () => AdminRoute
          })
const AdminEmailsRoute = AdminEmailsRouteImport.update({
            id: '/emails',path: '/emails',getParentRoute: () => AdminRoute
          })
const AdminHelocPricingRoute = AdminHelocPricingRouteImport.update({
            id: '/heloc-pricing',path: '/heloc-pricing',getParentRoute: () => AdminRoute
          })
const AdminIntegrationsHealthRoute = AdminIntegrationsHealthRouteImport.update({
            id: '/integrations-health',path: '/integrations-health',getParentRoute: () => AdminRoute
          })
const AdminLeadsRoute = AdminLeadsRouteImport.update({
            id: '/leads',path: '/leads',getParentRoute: () => AdminRoute
          })
const AdminOptimalBlueRoute = AdminOptimalBlueRouteImport.update({
            id: '/optimal-blue',path: '/optimal-blue',getParentRoute: () => AdminRoute
          })
const AdminPostsRoute = AdminPostsRouteImport.update({
            id: '/posts',path: '/posts',getParentRoute: () => AdminRoute
          })
const AdminPricingGroupsRoute = AdminPricingGroupsRouteImport.update({
            id: '/pricing-groups',path: '/pricing-groups',getParentRoute: () => AdminRoute
          })
const AdminSettingsRoute = AdminSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminRoute
          })
const AdminSiteAuditRoute = AdminSiteAuditRouteImport.update({
            id: '/site-audit',path: '/site-audit',getParentRoute: () => AdminRoute
          })
const AdminSocialRoute = AdminSocialRouteImport.update({
            id: '/social',path: '/social',getParentRoute: () => AdminRoute
          })
const AdminToolsRoute = AdminToolsRouteImport.update({
            id: '/tools',path: '/tools',getParentRoute: () => AdminRoute
          })
const AirbnbShortTermRentalLoansIndexRoute = AirbnbShortTermRentalLoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AirbnbShortTermRentalLoansRoute
          })
const AirbnbShortTermRentalLoansStateRoute = AirbnbShortTermRentalLoansStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => AirbnbShortTermRentalLoansRoute
          })
const ApplyIndexRoute = ApplyIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ApplyRoute
          })
const BlogIndexRoute = BlogIndexRouteImport.update({
            id: '/blog/',path: '/blog/',getParentRoute: () => rootRouteImport
          })
const BlogSlugRoute = BlogSlugRouteImport.update({
            id: '/blog/$slug',path: '/blog/$slug',getParentRoute: () => rootRouteImport
          })
const BridgeLoansIndexRoute = BridgeLoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => BridgeLoansRoute
          })
const BusinessSetupIndexRoute = BusinessSetupIndexRouteImport.update({
            id: '/business-setup/',path: '/business-setup/',getParentRoute: () => rootRouteImport
          })
const BusinessSetupBusinessBankAccountRoute = BusinessSetupBusinessBankAccountRouteImport.update({
            id: '/business-setup/business-bank-account',path: '/business-setup/business-bank-account',getParentRoute: () => rootRouteImport
          })
const BusinessSetupBusinessLoansRoute = BusinessSetupBusinessLoansRouteImport.update({
            id: '/business-setup/business-loans',path: '/business-setup/business-loans',getParentRoute: () => rootRouteImport
          })
const BusinessSetupDunsNumberRoute = BusinessSetupDunsNumberRouteImport.update({
            id: '/business-setup/duns-number',path: '/business-setup/duns-number',getParentRoute: () => rootRouteImport
          })
const BusinessSetupItinRoute = BusinessSetupItinRouteImport.update({
            id: '/business-setup/itin',path: '/business-setup/itin',getParentRoute: () => rootRouteImport
          })
const BusinessSetupLandlordInsuranceRoute = BusinessSetupLandlordInsuranceRouteImport.update({
            id: '/business-setup/landlord-insurance',path: '/business-setup/landlord-insurance',getParentRoute: () => rootRouteImport
          })
const BusinessSetupLlcRoute = BusinessSetupLlcRouteImport.update({
            id: '/business-setup/llc',path: '/business-setup/llc',getParentRoute: () => rootRouteImport
          })
const BusinessSetupLlcJourneyRoute = BusinessSetupLlcJourneyRouteImport.update({
            id: '/business-setup/llc-journey',path: '/business-setup/llc-journey',getParentRoute: () => rootRouteImport
          })
const BusinessSetupPropertyManagementSoftwareRoute = BusinessSetupPropertyManagementSoftwareRouteImport.update({
            id: '/business-setup/property-management-software',path: '/business-setup/property-management-software',getParentRoute: () => rootRouteImport
          })
const BusinessSetupTitleServicesRoute = BusinessSetupTitleServicesRouteImport.update({
            id: '/business-setup/title-services',path: '/business-setup/title-services',getParentRoute: () => rootRouteImport
          })
const CompareIndexRoute = CompareIndexRouteImport.update({
            id: '/compare/',path: '/compare/',getParentRoute: () => rootRouteImport
          })
const CompareSlugRoute = CompareSlugRouteImport.update({
            id: '/compare/$slug',path: '/compare/$slug',getParentRoute: () => rootRouteImport
          })
const ConstructionLoansIndexRoute = ConstructionLoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ConstructionLoansRoute
          })
const ConstructionLoansStateRoute = ConstructionLoansStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => ConstructionLoansRoute
          })
const DifficultDevelopmentAreasIndexRoute = DifficultDevelopmentAreasIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DifficultDevelopmentAreasRoute
          })
const DifficultDevelopmentAreasStateRoute = DifficultDevelopmentAreasStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => DifficultDevelopmentAreasRoute
          })
const DscrLoansIndexRoute = DscrLoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DscrLoansRoute
          })
const DscrLoansStateRoute = DscrLoansStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => DscrLoansRoute
          })
const EsIndexRoute = EsIndexRouteImport.update({
            id: '/es/',path: '/es/',getParentRoute: () => rootRouteImport
          })
const EsSplatRoute = EsSplatRouteImport.update({
            id: '/es/$',path: '/es/$',getParentRoute: () => rootRouteImport
          })
const EsBlogRoute = EsBlogRouteImport.update({
            id: '/es/blog',path: '/es/blog',getParentRoute: () => rootRouteImport
          })
const EsCalculadoraDscrRoute = EsCalculadoraDscrRouteImport.update({
            id: '/es/calculadora-dscr',path: '/es/calculadora-dscr',getParentRoute: () => rootRouteImport
          })
const EsCaminoDelInversionistaRoute = EsCaminoDelInversionistaRouteImport.update({
            id: '/es/camino-del-inversionista',path: '/es/camino-del-inversionista',getParentRoute: () => rootRouteImport
          })
const EsComoFuncionaDscrRoute = EsComoFuncionaDscrRouteImport.update({
            id: '/es/como-funciona-dscr',path: '/es/como-funciona-dscr',getParentRoute: () => rootRouteImport
          })
const EsContactoRoute = EsContactoRouteImport.update({
            id: '/es/contacto',path: '/es/contacto',getParentRoute: () => rootRouteImport
          })
const EsDondePrestamosRoute = EsDondePrestamosRouteImport.update({
            id: '/es/donde-prestamos',path: '/es/donde-prestamos',getParentRoute: () => rootRouteImport
          })
const EsGraciasRoute = EsGraciasRouteImport.update({
            id: '/es/gracias',path: '/es/gracias',getParentRoute: () => rootRouteImport
          })
const EsPreguntasFrecuentesRoute = EsPreguntasFrecuentesRouteImport.update({
            id: '/es/preguntas-frecuentes',path: '/es/preguntas-frecuentes',getParentRoute: () => rootRouteImport
          })
const EsPrestamosDscrRoute = EsPrestamosDscrRouteImport.update({
            id: '/es/prestamos-dscr',path: '/es/prestamos-dscr',getParentRoute: () => rootRouteImport
          })
const EsPrestamosExtranjerosRoute = EsPrestamosExtranjerosRouteImport.update({
            id: '/es/prestamos-extranjeros',path: '/es/prestamos-extranjeros',getParentRoute: () => rootRouteImport
          })
const EsPrestamosFixAndFlipRoute = EsPrestamosFixAndFlipRouteImport.update({
            id: '/es/prestamos-fix-and-flip',path: '/es/prestamos-fix-and-flip',getParentRoute: () => rootRouteImport
          })
const EsProcesoRoute = EsProcesoRouteImport.update({
            id: '/es/proceso',path: '/es/proceso',getParentRoute: () => rootRouteImport
          })
const EsRequisitosPrestamoDscrRoute = EsRequisitosPrestamoDscrRouteImport.update({
            id: '/es/requisitos-prestamo-dscr',path: '/es/requisitos-prestamo-dscr',getParentRoute: () => rootRouteImport
          })
const EsSobreNosotrosRoute = EsSobreNosotrosRouteImport.update({
            id: '/es/sobre-nosotros',path: '/es/sobre-nosotros',getParentRoute: () => rootRouteImport
          })
const EsSociosRoute = EsSociosRouteImport.update({
            id: '/es/socios',path: '/es/socios',getParentRoute: () => rootRouteImport
          })
const EsSolicitarRoute = EsSolicitarRouteImport.update({
            id: '/es/solicitar',path: '/es/solicitar',getParentRoute: () => rootRouteImport
          })
const EsTasasPrestamosDscrRoute = EsTasasPrestamosDscrRouteImport.update({
            id: '/es/tasas-prestamos-dscr',path: '/es/tasas-prestamos-dscr',getParentRoute: () => rootRouteImport
          })
const FixAndFlipLoansIndexRoute = FixAndFlipLoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => FixAndFlipLoansRoute
          })
const ForeignNationalLoansIndexRoute = ForeignNationalLoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ForeignNationalLoansRoute
          })
const ForeignNationalLoansStateRoute = ForeignNationalLoansStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => ForeignNationalLoansRoute
          })
const GlossaryIndexRoute = GlossaryIndexRouteImport.update({
            id: '/glossary/',path: '/glossary/',getParentRoute: () => rootRouteImport
          })
const GlossaryTermRoute = GlossaryTermRouteImport.update({
            id: '/glossary/$term',path: '/glossary/$term',getParentRoute: () => rootRouteImport
          })
const HardMoneyLoansIndexRoute = HardMoneyLoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HardMoneyLoansRoute
          })
const HudFairMarketRentsIndexRoute = HudFairMarketRentsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HudFairMarketRentsRoute
          })
const HudFairMarketRentsStateRoute = HudFairMarketRentsStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => HudFairMarketRentsRoute
          })
const HudIncomeLimitsIndexRoute = HudIncomeLimitsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => HudIncomeLimitsRoute
          })
const HudIncomeLimitsStateRoute = HudIncomeLimitsStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => HudIncomeLimitsRoute
          })
const LegalAccessibilityRoute = LegalAccessibilityRouteImport.update({
            id: '/legal/accessibility',path: '/legal/accessibility',getParentRoute: () => rootRouteImport
          })
const LegalCalculatorMethodologyRoute = LegalCalculatorMethodologyRouteImport.update({
            id: '/legal/calculator-methodology',path: '/legal/calculator-methodology',getParentRoute: () => rootRouteImport
          })
const LegalDisclaimersRoute = LegalDisclaimersRouteImport.update({
            id: '/legal/disclaimers',path: '/legal/disclaimers',getParentRoute: () => rootRouteImport
          })
const LegalEditorialStandardsRoute = LegalEditorialStandardsRouteImport.update({
            id: '/legal/editorial-standards',path: '/legal/editorial-standards',getParentRoute: () => rootRouteImport
          })
const LegalLicensingRoute = LegalLicensingRouteImport.update({
            id: '/legal/licensing',path: '/legal/licensing',getParentRoute: () => rootRouteImport
          })
const LegalPrivacyRoute = LegalPrivacyRouteImport.update({
            id: '/legal/privacy',path: '/legal/privacy',getParentRoute: () => rootRouteImport
          })
const LegalTermsRoute = LegalTermsRouteImport.update({
            id: '/legal/terms',path: '/legal/terms',getParentRoute: () => rootRouteImport
          })
const LoIndexRoute = LoIndexRouteImport.update({
            id: '/lo/',path: '/lo/',getParentRoute: () => rootRouteImport
          })
const LoDocumentsRoute = LoDocumentsRouteImport.update({
            id: '/lo/documents',path: '/lo/documents',getParentRoute: () => rootRouteImport
          })
const LoGuidelinesRoute = LoGuidelinesRouteImport.update({
            id: '/lo/guidelines',path: '/lo/guidelines',getParentRoute: () => rootRouteImport
          })
const LoStrReportRoute = LoStrReportRouteImport.update({
            id: '/lo/str-report',path: '/lo/str-report',getParentRoute: () => rootRouteImport
          })
const MultifamilyLoansIndexRoute = MultifamilyLoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => MultifamilyLoansRoute
          })
const PortfolioRentalLoansIndexRoute = PortfolioRentalLoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => PortfolioRentalLoansRoute
          })
const QualifiedCensusTractsIndexRoute = QualifiedCensusTractsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => QualifiedCensusTractsRoute
          })
const QualifiedCensusTractsStateRoute = QualifiedCensusTractsStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => QualifiedCensusTractsRoute
          })
const Section8LoansIndexRoute = Section8LoansIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => Section8LoansRoute
          })
const Section8LoansStateRoute = Section8LoansStateRouteImport.update({
            id: '/$state',path: '/$state',getParentRoute: () => Section8LoansRoute
          })
const ToolsCompareCitiesRoute = ToolsCompareCitiesRouteImport.update({
            id: '/tools/compare-cities',path: '/tools/compare-cities',getParentRoute: () => rootRouteImport
          })
const AdminBlogStatsIdRoute = AdminBlogStatsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminBlogStatsRoute
          })
const AdminChatbotIndexRoute = AdminChatbotIndexRouteImport.update({
            id: '/chatbot/',path: '/chatbot/',getParentRoute: () => AdminRoute
          })
const AdminChatbotConversationsRoute = AdminChatbotConversationsRouteImport.update({
            id: '/chatbot/conversations',path: '/chatbot/conversations',getParentRoute: () => AdminRoute
          })
const AdminChatbotKnowledgeRoute = AdminChatbotKnowledgeRouteImport.update({
            id: '/chatbot/knowledge',path: '/chatbot/knowledge',getParentRoute: () => AdminRoute
          })
const AdminChatbotReviewRoute = AdminChatbotReviewRouteImport.update({
            id: '/chatbot/review',path: '/chatbot/review',getParentRoute: () => AdminRoute
          })
const AdminChatbotTrainingRoute = AdminChatbotTrainingRouteImport.update({
            id: '/chatbot/training',path: '/chatbot/training',getParentRoute: () => AdminRoute
          })
const AdminChatbotTransferRoute = AdminChatbotTransferRouteImport.update({
            id: '/chatbot/transfer',path: '/chatbot/transfer',getParentRoute: () => AdminRoute
          })
const AdminPostsIndexRoute = AdminPostsIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminPostsRoute
          })
const AdminPostsIdRoute = AdminPostsIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => AdminPostsRoute
          })
const AdminPostsNewRoute = AdminPostsNewRouteImport.update({
            id: '/new',path: '/new',getParentRoute: () => AdminPostsRoute
          })
const AdminSeoIndexRoute = AdminSeoIndexRouteImport.update({
            id: '/seo/',path: '/seo/',getParentRoute: () => AdminRoute
          })
const AdminSeoAiVisibilityRoute = AdminSeoAiVisibilityRouteImport.update({
            id: '/seo/ai-visibility',path: '/seo/ai-visibility',getParentRoute: () => AdminRoute
          })
const AdminSeoAutopilotRoute = AdminSeoAutopilotRouteImport.update({
            id: '/seo/autopilot',path: '/seo/autopilot',getParentRoute: () => AdminRoute
          })
const AdminSeoCannibalizationRoute = AdminSeoCannibalizationRouteImport.update({
            id: '/seo/cannibalization',path: '/seo/cannibalization',getParentRoute: () => AdminRoute
          })
const AdminSeoCompetitorsRoute = AdminSeoCompetitorsRouteImport.update({
            id: '/seo/competitors',path: '/seo/competitors',getParentRoute: () => AdminRoute
          })
const AdminSeoContentFreshnessRoute = AdminSeoContentFreshnessRouteImport.update({
            id: '/seo/content-freshness',path: '/seo/content-freshness',getParentRoute: () => AdminRoute
          })
const AdminSeoContentHygieneRoute = AdminSeoContentHygieneRouteImport.update({
            id: '/seo/content-hygiene',path: '/seo/content-hygiene',getParentRoute: () => AdminRoute
          })
const AdminSeoConversionsRoute = AdminSeoConversionsRouteImport.update({
            id: '/seo/conversions',path: '/seo/conversions',getParentRoute: () => AdminRoute
          })
const AdminSeoCtrRoute = AdminSeoCtrRouteImport.update({
            id: '/seo/ctr',path: '/seo/ctr',getParentRoute: () => AdminRoute
          })
const AdminSeoCycleRoute = AdminSeoCycleRouteImport.update({
            id: '/seo/cycle',path: '/seo/cycle',getParentRoute: () => AdminRoute
          })
const AdminSeoFirecrawlRoute = AdminSeoFirecrawlRouteImport.update({
            id: '/seo/firecrawl',path: '/seo/firecrawl',getParentRoute: () => AdminRoute
          })
const AdminSeoFixCenterRoute = AdminSeoFixCenterRouteImport.update({
            id: '/seo/fix-center',path: '/seo/fix-center',getParentRoute: () => AdminRoute
          })
const AdminSeoIndexCoverageRoute = AdminSeoIndexCoverageRouteImport.update({
            id: '/seo/index-coverage',path: '/seo/index-coverage',getParentRoute: () => AdminRoute
          })
const AdminSeoIntegrationsRoute = AdminSeoIntegrationsRouteImport.update({
            id: '/seo/integrations',path: '/seo/integrations',getParentRoute: () => AdminRoute
          })
const AdminSeoInternalLinksRoute = AdminSeoInternalLinksRouteImport.update({
            id: '/seo/internal-links',path: '/seo/internal-links',getParentRoute: () => AdminRoute
          })
const AdminSeoLinkCheckRoute = AdminSeoLinkCheckRouteImport.update({
            id: '/seo/link-check',path: '/seo/link-check',getParentRoute: () => AdminRoute
          })
const AdminSeoLinkInjectorRoute = AdminSeoLinkInjectorRouteImport.update({
            id: '/seo/link-injector',path: '/seo/link-injector',getParentRoute: () => AdminRoute
          })
const AdminSeoMissingPagesRoute = AdminSeoMissingPagesRouteImport.update({
            id: '/seo/missing-pages',path: '/seo/missing-pages',getParentRoute: () => AdminRoute
          })
const AdminSeoPerformanceRoute = AdminSeoPerformanceRouteImport.update({
            id: '/seo/performance',path: '/seo/performance',getParentRoute: () => AdminRoute
          })
const AdminSeoPublishActionsRoute = AdminSeoPublishActionsRouteImport.update({
            id: '/seo/publish-actions',path: '/seo/publish-actions',getParentRoute: () => AdminRoute
          })
const AdminSeoQaImpactRoute = AdminSeoQaImpactRouteImport.update({
            id: '/seo/qa-impact',path: '/seo/qa-impact',getParentRoute: () => AdminRoute
          })
const AdminSeoRankTrackerRoute = AdminSeoRankTrackerRouteImport.update({
            id: '/seo/rank-tracker',path: '/seo/rank-tracker',getParentRoute: () => AdminRoute
          })
const AdminSeoReportsRoute = AdminSeoReportsRouteImport.update({
            id: '/seo/reports',path: '/seo/reports',getParentRoute: () => AdminRoute
          })
const AdminSeoRulesRoute = AdminSeoRulesRouteImport.update({
            id: '/seo/rules',path: '/seo/rules',getParentRoute: () => AdminRoute
          })
const AdminSeoSiteHealthRoute = AdminSeoSiteHealthRouteImport.update({
            id: '/seo/site-health',path: '/seo/site-health',getParentRoute: () => AdminRoute
          })
const AdminSeoTopicGapsRoute = AdminSeoTopicGapsRouteImport.update({
            id: '/seo/topic-gaps',path: '/seo/topic-gaps',getParentRoute: () => AdminRoute
          })
const AdminSeoWebVitalsRoute = AdminSeoWebVitalsRouteImport.update({
            id: '/seo/web-vitals',path: '/seo/web-vitals',getParentRoute: () => AdminRoute
          })
const AdminSocialIndexRoute = AdminSocialIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialAccountsRoute = AdminSocialAccountsRouteImport.update({
            id: '/accounts',path: '/accounts',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialAnalyticsRoute = AdminSocialAnalyticsRouteImport.update({
            id: '/analytics',path: '/analytics',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialBulkRoute = AdminSocialBulkRouteImport.update({
            id: '/bulk',path: '/bulk',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialCalendarRoute = AdminSocialCalendarRouteImport.update({
            id: '/calendar',path: '/calendar',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialCommentsRoute = AdminSocialCommentsRouteImport.update({
            id: '/comments',path: '/comments',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialComplianceRoute = AdminSocialComplianceRouteImport.update({
            id: '/compliance',path: '/compliance',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialComposeRoute = AdminSocialComposeRouteImport.update({
            id: '/compose',path: '/compose',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialConnectRoute = AdminSocialConnectRouteImport.update({
            id: '/connect',path: '/connect',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialConnectGhlRoute = AdminSocialConnectGhlRouteImport.update({
            id: '/connect-ghl',path: '/connect-ghl',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialDiagnosticsRoute = AdminSocialDiagnosticsRouteImport.update({
            id: '/diagnostics',path: '/diagnostics',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialDraftsRoute = AdminSocialDraftsRouteImport.update({
            id: '/drafts',path: '/drafts',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialEvergreenRoute = AdminSocialEvergreenRouteImport.update({
            id: '/evergreen',path: '/evergreen',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialEvergreenGuideRoute = AdminSocialEvergreenGuideRouteImport.update({
            id: '/evergreen-guide',path: '/evergreen-guide',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialGuideRoute = AdminSocialGuideRouteImport.update({
            id: '/guide',path: '/guide',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialInboxRoute = AdminSocialInboxRouteImport.update({
            id: '/inbox',path: '/inbox',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialQueueRoute = AdminSocialQueueRouteImport.update({
            id: '/queue',path: '/queue',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialReplyLogRoute = AdminSocialReplyLogRouteImport.update({
            id: '/reply-log',path: '/reply-log',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialSettingsRoute = AdminSocialSettingsRouteImport.update({
            id: '/settings',path: '/settings',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialSetupGuideRoute = AdminSocialSetupGuideRouteImport.update({
            id: '/setup-guide',path: '/setup-guide',getParentRoute: () => AdminSocialRoute
          })
const AdminSocialTeamSetupRoute = AdminSocialTeamSetupRouteImport.update({
            id: '/team-setup',path: '/team-setup',getParentRoute: () => AdminSocialRoute
          })
const AirbnbShortTermRentalLoansStateIndexRoute = AirbnbShortTermRentalLoansStateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => AirbnbShortTermRentalLoansStateRoute
          })
const AirbnbShortTermRentalLoansStateCityRoute = AirbnbShortTermRentalLoansStateCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => AirbnbShortTermRentalLoansStateRoute
          })
const ApplyThanksProductRoute = ApplyThanksProductRouteImport.update({
            id: '/thanks/$product',path: '/thanks/$product',getParentRoute: () => ApplyRoute
          })
const BridgeLoansStateIndexRoute = BridgeLoansStateIndexRouteImport.update({
            id: '/$state/',path: '/$state/',getParentRoute: () => BridgeLoansRoute
          })
const BridgeLoansStateCityRoute = BridgeLoansStateCityRouteImport.update({
            id: '/$state/$city',path: '/$state/$city',getParentRoute: () => BridgeLoansRoute
          })
const ConstructionLoansStateIndexRoute = ConstructionLoansStateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ConstructionLoansStateRoute
          })
const ConstructionLoansStateCityRoute = ConstructionLoansStateCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => ConstructionLoansStateRoute
          })
const DscrLoansStateIndexRoute = DscrLoansStateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => DscrLoansStateRoute
          })
const DscrLoansStateCityRoute = DscrLoansStateCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => DscrLoansStateRoute
          })
const EsLegalAccesibilidadRoute = EsLegalAccesibilidadRouteImport.update({
            id: '/es/legal/accesibilidad',path: '/es/legal/accesibilidad',getParentRoute: () => rootRouteImport
          })
const EsLegalDivulgacionesRoute = EsLegalDivulgacionesRouteImport.update({
            id: '/es/legal/divulgaciones',path: '/es/legal/divulgaciones',getParentRoute: () => rootRouteImport
          })
const EsLegalLicenciasRoute = EsLegalLicenciasRouteImport.update({
            id: '/es/legal/licencias',path: '/es/legal/licencias',getParentRoute: () => rootRouteImport
          })
const EsLegalPrivacidadRoute = EsLegalPrivacidadRouteImport.update({
            id: '/es/legal/privacidad',path: '/es/legal/privacidad',getParentRoute: () => rootRouteImport
          })
const EsLegalTerminosRoute = EsLegalTerminosRouteImport.update({
            id: '/es/legal/terminos',path: '/es/legal/terminos',getParentRoute: () => rootRouteImport
          })
const EsPrestamosDscrIndexRoute = EsPrestamosDscrIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EsPrestamosDscrRoute
          })
const EsSolicitarIndexRoute = EsSolicitarIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => EsSolicitarRoute
          })
const FixAndFlipLoansStateIndexRoute = FixAndFlipLoansStateIndexRouteImport.update({
            id: '/$state/',path: '/$state/',getParentRoute: () => FixAndFlipLoansRoute
          })
const FixAndFlipLoansStateCityRoute = FixAndFlipLoansStateCityRouteImport.update({
            id: '/$state/$city',path: '/$state/$city',getParentRoute: () => FixAndFlipLoansRoute
          })
const ForeignNationalLoansStateIndexRoute = ForeignNationalLoansStateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => ForeignNationalLoansStateRoute
          })
const ForeignNationalLoansStateCityRoute = ForeignNationalLoansStateCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => ForeignNationalLoansStateRoute
          })
const HardMoneyLoansStateIndexRoute = HardMoneyLoansStateIndexRouteImport.update({
            id: '/$state/',path: '/$state/',getParentRoute: () => HardMoneyLoansRoute
          })
const MultifamilyLoansStateIndexRoute = MultifamilyLoansStateIndexRouteImport.update({
            id: '/$state/',path: '/$state/',getParentRoute: () => MultifamilyLoansRoute
          })
const PortfolioRentalLoansStateIndexRoute = PortfolioRentalLoansStateIndexRouteImport.update({
            id: '/$state/',path: '/$state/',getParentRoute: () => PortfolioRentalLoansRoute
          })
const PortfolioRentalLoansStateCityRoute = PortfolioRentalLoansStateCityRouteImport.update({
            id: '/$state/$city',path: '/$state/$city',getParentRoute: () => PortfolioRentalLoansRoute
          })
const Section8LoansStateIndexRoute = Section8LoansStateIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => Section8LoansStateRoute
          })
const Section8LoansStateCityRoute = Section8LoansStateCityRouteImport.update({
            id: '/$city',path: '/$city',getParentRoute: () => Section8LoansStateRoute
          })
const AdminPostsIdPreviewRoute = AdminPostsIdPreviewRouteImport.update({
            id: '/$id_/preview',path: '/$id/preview',getParentRoute: () => AdminPostsRoute
          })





const AdminBlogStatsRouteChildren = {
  AdminBlogStatsIdRoute: AdminBlogStatsIdRoute
}

const AdminBlogStatsRouteWithChildren = AdminBlogStatsRoute._addFileChildren(AdminBlogStatsRouteChildren)




const AdminPostsRouteChildren = {
  AdminPostsIdRoute: AdminPostsIdRoute,AdminPostsNewRoute: AdminPostsNewRoute,AdminPostsIndexRoute: AdminPostsIndexRoute,AdminPostsIdPreviewRoute: AdminPostsIdPreviewRoute
}

const AdminPostsRouteWithChildren = AdminPostsRoute._addFileChildren(AdminPostsRouteChildren)




const AdminSocialRouteChildren = {
  AdminSocialAccountsRoute: AdminSocialAccountsRoute,AdminSocialAnalyticsRoute: AdminSocialAnalyticsRoute,AdminSocialBulkRoute: AdminSocialBulkRoute,AdminSocialCalendarRoute: AdminSocialCalendarRoute,AdminSocialCommentsRoute: AdminSocialCommentsRoute,AdminSocialComplianceRoute: AdminSocialComplianceRoute,AdminSocialComposeRoute: AdminSocialComposeRoute,AdminSocialConnectRoute: AdminSocialConnectRoute,AdminSocialConnectGhlRoute: AdminSocialConnectGhlRoute,AdminSocialDiagnosticsRoute: AdminSocialDiagnosticsRoute,AdminSocialDraftsRoute: AdminSocialDraftsRoute,AdminSocialEvergreenRoute: AdminSocialEvergreenRoute,AdminSocialEvergreenGuideRoute: AdminSocialEvergreenGuideRoute,AdminSocialGuideRoute: AdminSocialGuideRoute,AdminSocialInboxRoute: AdminSocialInboxRoute,AdminSocialQueueRoute: AdminSocialQueueRoute,AdminSocialReplyLogRoute: AdminSocialReplyLogRoute,AdminSocialSettingsRoute: AdminSocialSettingsRoute,AdminSocialSetupGuideRoute: AdminSocialSetupGuideRoute,AdminSocialTeamSetupRoute: AdminSocialTeamSetupRoute,AdminSocialIndexRoute: AdminSocialIndexRoute
}

const AdminSocialRouteWithChildren = AdminSocialRoute._addFileChildren(AdminSocialRouteChildren)



const AdminRouteChildren = {
  AdminApiHealthRoute: AdminApiHealthRoute,AdminBlogAgentRoute: AdminBlogAgentRoute,AdminBlogCalendarRoute: AdminBlogCalendarRoute,AdminBlogClustersRoute: AdminBlogClustersRoute,AdminBlogGscOpportunitiesRoute: AdminBlogGscOpportunitiesRoute,AdminBlogPublishQueueRoute: AdminBlogPublishQueueRoute,AdminBlogScheduleRoute: AdminBlogScheduleRoute,AdminBlogStatsRoute: AdminBlogStatsRouteWithChildren,AdminBlogTopicsRoute: AdminBlogTopicsRoute,AdminBlogVideosRoute: AdminBlogVideosRoute,AdminComplianceRoute: AdminComplianceRoute,AdminEmailsRoute: AdminEmailsRoute,AdminHelocPricingRoute: AdminHelocPricingRoute,AdminIntegrationsHealthRoute: AdminIntegrationsHealthRoute,AdminLeadsRoute: AdminLeadsRoute,AdminOptimalBlueRoute: AdminOptimalBlueRoute,AdminPostsRoute: AdminPostsRouteWithChildren,AdminPricingGroupsRoute: AdminPricingGroupsRoute,AdminSettingsRoute: AdminSettingsRoute,AdminSiteAuditRoute: AdminSiteAuditRoute,AdminSocialRoute: AdminSocialRouteWithChildren,AdminToolsRoute: AdminToolsRoute,AdminIndexRoute: AdminIndexRoute,AdminChatbotConversationsRoute: AdminChatbotConversationsRoute,AdminChatbotKnowledgeRoute: AdminChatbotKnowledgeRoute,AdminChatbotReviewRoute: AdminChatbotReviewRoute,AdminChatbotTrainingRoute: AdminChatbotTrainingRoute,AdminChatbotTransferRoute: AdminChatbotTransferRoute,AdminSeoAiVisibilityRoute: AdminSeoAiVisibilityRoute,AdminSeoAutopilotRoute: AdminSeoAutopilotRoute,AdminSeoCannibalizationRoute: AdminSeoCannibalizationRoute,AdminSeoCompetitorsRoute: AdminSeoCompetitorsRoute,AdminSeoContentFreshnessRoute: AdminSeoContentFreshnessRoute,AdminSeoContentHygieneRoute: AdminSeoContentHygieneRoute,AdminSeoConversionsRoute: AdminSeoConversionsRoute,AdminSeoCtrRoute: AdminSeoCtrRoute,AdminSeoCycleRoute: AdminSeoCycleRoute,AdminSeoFirecrawlRoute: AdminSeoFirecrawlRoute,AdminSeoFixCenterRoute: AdminSeoFixCenterRoute,AdminSeoIndexCoverageRoute: AdminSeoIndexCoverageRoute,AdminSeoIntegrationsRoute: AdminSeoIntegrationsRoute,AdminSeoInternalLinksRoute: AdminSeoInternalLinksRoute,AdminSeoLinkCheckRoute: AdminSeoLinkCheckRoute,AdminSeoLinkInjectorRoute: AdminSeoLinkInjectorRoute,AdminSeoMissingPagesRoute: AdminSeoMissingPagesRoute,AdminSeoPerformanceRoute: AdminSeoPerformanceRoute,AdminSeoPublishActionsRoute: AdminSeoPublishActionsRoute,AdminSeoQaImpactRoute: AdminSeoQaImpactRoute,AdminSeoRankTrackerRoute: AdminSeoRankTrackerRoute,AdminSeoReportsRoute: AdminSeoReportsRoute,AdminSeoRulesRoute: AdminSeoRulesRoute,AdminSeoSiteHealthRoute: AdminSeoSiteHealthRoute,AdminSeoTopicGapsRoute: AdminSeoTopicGapsRoute,AdminSeoWebVitalsRoute: AdminSeoWebVitalsRoute,AdminChatbotIndexRoute: AdminChatbotIndexRoute,AdminSeoIndexRoute: AdminSeoIndexRoute
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)




const AirbnbShortTermRentalLoansStateRouteChildren = {
  AirbnbShortTermRentalLoansStateCityRoute: AirbnbShortTermRentalLoansStateCityRoute,AirbnbShortTermRentalLoansStateIndexRoute: AirbnbShortTermRentalLoansStateIndexRoute
}

const AirbnbShortTermRentalLoansStateRouteWithChildren = AirbnbShortTermRentalLoansStateRoute._addFileChildren(AirbnbShortTermRentalLoansStateRouteChildren)



const AirbnbShortTermRentalLoansRouteChildren = {
  AirbnbShortTermRentalLoansStateRoute: AirbnbShortTermRentalLoansStateRouteWithChildren,AirbnbShortTermRentalLoansIndexRoute: AirbnbShortTermRentalLoansIndexRoute
}

const AirbnbShortTermRentalLoansRouteWithChildren = AirbnbShortTermRentalLoansRoute._addFileChildren(AirbnbShortTermRentalLoansRouteChildren)




const ApplyRouteChildren = {
  ApplyIndexRoute: ApplyIndexRoute,ApplyThanksProductRoute: ApplyThanksProductRoute
}

const ApplyRouteWithChildren = ApplyRoute._addFileChildren(ApplyRouteChildren)




const BridgeLoansRouteChildren = {
  BridgeLoansIndexRoute: BridgeLoansIndexRoute,BridgeLoansStateCityRoute: BridgeLoansStateCityRoute,BridgeLoansStateIndexRoute: BridgeLoansStateIndexRoute
}

const BridgeLoansRouteWithChildren = BridgeLoansRoute._addFileChildren(BridgeLoansRouteChildren)




const ConstructionLoansStateRouteChildren = {
  ConstructionLoansStateCityRoute: ConstructionLoansStateCityRoute,ConstructionLoansStateIndexRoute: ConstructionLoansStateIndexRoute
}

const ConstructionLoansStateRouteWithChildren = ConstructionLoansStateRoute._addFileChildren(ConstructionLoansStateRouteChildren)



const ConstructionLoansRouteChildren = {
  ConstructionLoansStateRoute: ConstructionLoansStateRouteWithChildren,ConstructionLoansIndexRoute: ConstructionLoansIndexRoute
}

const ConstructionLoansRouteWithChildren = ConstructionLoansRoute._addFileChildren(ConstructionLoansRouteChildren)




const DifficultDevelopmentAreasRouteChildren = {
  DifficultDevelopmentAreasStateRoute: DifficultDevelopmentAreasStateRoute,DifficultDevelopmentAreasIndexRoute: DifficultDevelopmentAreasIndexRoute
}

const DifficultDevelopmentAreasRouteWithChildren = DifficultDevelopmentAreasRoute._addFileChildren(DifficultDevelopmentAreasRouteChildren)




const DscrLoansStateRouteChildren = {
  DscrLoansStateCityRoute: DscrLoansStateCityRoute,DscrLoansStateIndexRoute: DscrLoansStateIndexRoute
}

const DscrLoansStateRouteWithChildren = DscrLoansStateRoute._addFileChildren(DscrLoansStateRouteChildren)



const DscrLoansRouteChildren = {
  DscrLoansStateRoute: DscrLoansStateRouteWithChildren,DscrLoansIndexRoute: DscrLoansIndexRoute
}

const DscrLoansRouteWithChildren = DscrLoansRoute._addFileChildren(DscrLoansRouteChildren)




const FixAndFlipLoansRouteChildren = {
  FixAndFlipLoansIndexRoute: FixAndFlipLoansIndexRoute,FixAndFlipLoansStateCityRoute: FixAndFlipLoansStateCityRoute,FixAndFlipLoansStateIndexRoute: FixAndFlipLoansStateIndexRoute
}

const FixAndFlipLoansRouteWithChildren = FixAndFlipLoansRoute._addFileChildren(FixAndFlipLoansRouteChildren)




const ForeignNationalLoansStateRouteChildren = {
  ForeignNationalLoansStateCityRoute: ForeignNationalLoansStateCityRoute,ForeignNationalLoansStateIndexRoute: ForeignNationalLoansStateIndexRoute
}

const ForeignNationalLoansStateRouteWithChildren = ForeignNationalLoansStateRoute._addFileChildren(ForeignNationalLoansStateRouteChildren)



const ForeignNationalLoansRouteChildren = {
  ForeignNationalLoansStateRoute: ForeignNationalLoansStateRouteWithChildren,ForeignNationalLoansIndexRoute: ForeignNationalLoansIndexRoute
}

const ForeignNationalLoansRouteWithChildren = ForeignNationalLoansRoute._addFileChildren(ForeignNationalLoansRouteChildren)




const HardMoneyLoansRouteChildren = {
  HardMoneyLoansIndexRoute: HardMoneyLoansIndexRoute,HardMoneyLoansStateIndexRoute: HardMoneyLoansStateIndexRoute
}

const HardMoneyLoansRouteWithChildren = HardMoneyLoansRoute._addFileChildren(HardMoneyLoansRouteChildren)




const HudFairMarketRentsRouteChildren = {
  HudFairMarketRentsStateRoute: HudFairMarketRentsStateRoute,HudFairMarketRentsIndexRoute: HudFairMarketRentsIndexRoute
}

const HudFairMarketRentsRouteWithChildren = HudFairMarketRentsRoute._addFileChildren(HudFairMarketRentsRouteChildren)




const HudIncomeLimitsRouteChildren = {
  HudIncomeLimitsStateRoute: HudIncomeLimitsStateRoute,HudIncomeLimitsIndexRoute: HudIncomeLimitsIndexRoute
}

const HudIncomeLimitsRouteWithChildren = HudIncomeLimitsRoute._addFileChildren(HudIncomeLimitsRouteChildren)




const MultifamilyLoansRouteChildren = {
  MultifamilyLoansIndexRoute: MultifamilyLoansIndexRoute,MultifamilyLoansStateIndexRoute: MultifamilyLoansStateIndexRoute
}

const MultifamilyLoansRouteWithChildren = MultifamilyLoansRoute._addFileChildren(MultifamilyLoansRouteChildren)




const PortfolioRentalLoansRouteChildren = {
  PortfolioRentalLoansIndexRoute: PortfolioRentalLoansIndexRoute,PortfolioRentalLoansStateCityRoute: PortfolioRentalLoansStateCityRoute,PortfolioRentalLoansStateIndexRoute: PortfolioRentalLoansStateIndexRoute
}

const PortfolioRentalLoansRouteWithChildren = PortfolioRentalLoansRoute._addFileChildren(PortfolioRentalLoansRouteChildren)




const QualifiedCensusTractsRouteChildren = {
  QualifiedCensusTractsStateRoute: QualifiedCensusTractsStateRoute,QualifiedCensusTractsIndexRoute: QualifiedCensusTractsIndexRoute
}

const QualifiedCensusTractsRouteWithChildren = QualifiedCensusTractsRoute._addFileChildren(QualifiedCensusTractsRouteChildren)




const Section8LoansStateRouteChildren = {
  Section8LoansStateCityRoute: Section8LoansStateCityRoute,Section8LoansStateIndexRoute: Section8LoansStateIndexRoute
}

const Section8LoansStateRouteWithChildren = Section8LoansStateRoute._addFileChildren(Section8LoansStateRouteChildren)



const Section8LoansRouteChildren = {
  Section8LoansStateRoute: Section8LoansStateRouteWithChildren,Section8LoansIndexRoute: Section8LoansIndexRoute
}

const Section8LoansRouteWithChildren = Section8LoansRoute._addFileChildren(Section8LoansRouteChildren)




const EsPrestamosDscrRouteChildren = {
  EsPrestamosDscrIndexRoute: EsPrestamosDscrIndexRoute
}

const EsPrestamosDscrRouteWithChildren = EsPrestamosDscrRoute._addFileChildren(EsPrestamosDscrRouteChildren)




const EsSolicitarRouteChildren = {
  EsSolicitarIndexRoute: EsSolicitarIndexRoute
}

const EsSolicitarRouteWithChildren = EsSolicitarRoute._addFileChildren(EsSolicitarRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AboutRoute: AboutRoute,AdminRoute: AdminRouteWithChildren,AirbnbShortTermRentalLoansRoute: AirbnbShortTermRentalLoansRouteWithChildren,ApplyRoute: ApplyRouteWithChildren,ArvCalculatorRoute: ArvCalculatorRoute,AuthRoute: AuthRoute,BestRentalMarketsRoute: BestRentalMarketsRoute,BridgeLoansRoute: BridgeLoansRouteWithChildren,BrrrrCalculatorRoute: BrrrrCalculatorRoute,CapRateCalculatorRoute: CapRateCalculatorRoute,CashOnCashReturnCalculatorRoute: CashOnCashReturnCalculatorRoute,CashOutRefinanceCalculatorRoute: CashOutRefinanceCalculatorRoute,ClosingCostCalculatorRoute: ClosingCostCalculatorRoute,ConstructionLoansRoute: ConstructionLoansRouteWithChildren,ContactRoute: ContactRoute,DifficultDevelopmentAreasRoute: DifficultDevelopmentAreasRouteWithChildren,DscrCalculatorRoute: DscrCalculatorRoute,DscrCashOutRefinanceRoute: DscrCashOutRefinanceRoute,DscrHelocRoute: DscrHelocRoute,DscrHelocRatesRoute: DscrHelocRatesRoute,DscrLoanProsAndConsRoute: DscrLoanProsAndConsRoute,DscrLoanRatesRoute: DscrLoanRatesRoute,DscrLoanRequirementsRoute: DscrLoanRequirementsRoute,DscrLoansRoute: DscrLoansRouteWithChildren,DscrPaymentCalculatorRoute: DscrPaymentCalculatorRoute,DscrRateHistoryRoute: DscrRateHistoryRoute,DscrRateTermRefinanceRoute: DscrRateTermRefinanceRoute,DscrSecondLienHelocRoute: DscrSecondLienHelocRoute,FaqRoute: FaqRoute,FhaLoanRatesRoute: FhaLoanRatesRoute,FixAndFlipLoansRoute: FixAndFlipLoansRouteWithChildren,ForeignNationalLoansRoute: ForeignNationalLoansRouteWithChildren,HardMoneyLoansRoute: HardMoneyLoansRouteWithChildren,HowDscrWorksRoute: HowDscrWorksRoute,HudFairMarketRentsRoute: HudFairMarketRentsRouteWithChildren,HudIncomeLimitsRoute: HudIncomeLimitsRouteWithChildren,InterestOnlyDscrLoansRoute: InterestOnlyDscrLoansRoute,InterestOnlyVsAmortizingCalculatorRoute: InterestOnlyVsAmortizingCalculatorRoute,InvestmentPropertyRatesRoute: InvestmentPropertyRatesRoute,InvestorJourneyRoute: InvestorJourneyRoute,LtvEquityCalculatorRoute: LtvEquityCalculatorRoute,MidTermRentalLoansRoute: MidTermRentalLoansRoute,MultifamilyLoansRoute: MultifamilyLoansRouteWithChildren,NoRatioDscrLoansRoute: NoRatioDscrLoansRoute,PartnersRoute: PartnersRoute,PortfolioRentalLoansRoute: PortfolioRentalLoansRouteWithChildren,PrepaymentPenaltyCalculatorRoute: PrepaymentPenaltyCalculatorRoute,ProcessRoute: ProcessRoute,QualifiedCensusTractsRoute: QualifiedCensusTractsRouteWithChildren,RatesRoute: RatesRoute,RentNeededForDscrRoute: RentNeededForDscrRoute,RentalPropertyDealAnalyzerRoute: RentalPropertyDealAnalyzerRoute,ResetPasswordRoute: ResetPasswordRoute,Section8InvestingMapRoute: Section8InvestingMapRoute,Section8LoansRoute: Section8LoansRouteWithChildren,ThankYouRoute: ThankYouRoute,UnsubscribeRoute: UnsubscribeRoute,WhereWeLendRoute: WhereWeLendRoute,BlogSlugRoute: BlogSlugRoute,BusinessSetupBusinessBankAccountRoute: BusinessSetupBusinessBankAccountRoute,BusinessSetupBusinessLoansRoute: BusinessSetupBusinessLoansRoute,BusinessSetupDunsNumberRoute: BusinessSetupDunsNumberRoute,BusinessSetupItinRoute: BusinessSetupItinRoute,BusinessSetupLandlordInsuranceRoute: BusinessSetupLandlordInsuranceRoute,BusinessSetupLlcRoute: BusinessSetupLlcRoute,BusinessSetupLlcJourneyRoute: BusinessSetupLlcJourneyRoute,BusinessSetupPropertyManagementSoftwareRoute: BusinessSetupPropertyManagementSoftwareRoute,BusinessSetupTitleServicesRoute: BusinessSetupTitleServicesRoute,CompareSlugRoute: CompareSlugRoute,EsSplatRoute: EsSplatRoute,EsBlogRoute: EsBlogRoute,EsCalculadoraDscrRoute: EsCalculadoraDscrRoute,EsCaminoDelInversionistaRoute: EsCaminoDelInversionistaRoute,EsComoFuncionaDscrRoute: EsComoFuncionaDscrRoute,EsContactoRoute: EsContactoRoute,EsDondePrestamosRoute: EsDondePrestamosRoute,EsGraciasRoute: EsGraciasRoute,EsPreguntasFrecuentesRoute: EsPreguntasFrecuentesRoute,EsPrestamosDscrRoute: EsPrestamosDscrRouteWithChildren,EsPrestamosExtranjerosRoute: EsPrestamosExtranjerosRoute,EsPrestamosFixAndFlipRoute: EsPrestamosFixAndFlipRoute,EsProcesoRoute: EsProcesoRoute,EsRequisitosPrestamoDscrRoute: EsRequisitosPrestamoDscrRoute,EsSobreNosotrosRoute: EsSobreNosotrosRoute,EsSociosRoute: EsSociosRoute,EsSolicitarRoute: EsSolicitarRouteWithChildren,EsTasasPrestamosDscrRoute: EsTasasPrestamosDscrRoute,GlossaryTermRoute: GlossaryTermRoute,LegalAccessibilityRoute: LegalAccessibilityRoute,LegalCalculatorMethodologyRoute: LegalCalculatorMethodologyRoute,LegalDisclaimersRoute: LegalDisclaimersRoute,LegalEditorialStandardsRoute: LegalEditorialStandardsRoute,LegalLicensingRoute: LegalLicensingRoute,LegalPrivacyRoute: LegalPrivacyRoute,LegalTermsRoute: LegalTermsRoute,LoDocumentsRoute: LoDocumentsRoute,LoGuidelinesRoute: LoGuidelinesRoute,LoStrReportRoute: LoStrReportRoute,ToolsCompareCitiesRoute: ToolsCompareCitiesRoute,BlogIndexRoute: BlogIndexRoute,BusinessSetupIndexRoute: BusinessSetupIndexRoute,CompareIndexRoute: CompareIndexRoute,EsIndexRoute: EsIndexRoute,GlossaryIndexRoute: GlossaryIndexRoute,LoIndexRoute: LoIndexRoute,EsLegalAccesibilidadRoute: EsLegalAccesibilidadRoute,EsLegalDivulgacionesRoute: EsLegalDivulgacionesRoute,EsLegalLicenciasRoute: EsLegalLicenciasRoute,EsLegalPrivacidadRoute: EsLegalPrivacidadRoute,EsLegalTerminosRoute: EsLegalTerminosRoute
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)